<template>
  <label
    v-bind="$attrs"
    v-on="$listeners"
    style="color: #F56C6C">*
    <span class="color666">
      <slot></slot>
    </span>
  </label>
</template>

<script>
    export default {
        name: "gj-required"
    }
</script>

<style scoped>
  .color666 {
    color: #666;
  }
</style>
